import { gql } from '@apollo/client';
import { LinkFragment } from '@landsbankinn/shared/graphql/prismic/fragments/linkFragment';
import { arsskyrslaFragments } from './fragments/arsskyrslaFragments';
import { allFragments } from './fragments/sliceFragments';

function getChunks(fragments: any[], chunks: number) {
  const res = [];
  /* Puts all together, then splits it evenly amoung sub arrays (remainders are included) */
  for (let i = chunks; i > 0; i--) {
    res.push(fragments.splice(0, Math.ceil(fragments.length / i)));
  }
  return res;
}

const chunks = getChunks([...allFragments, ...arsskyrslaFragments], 3);

export const pageQueries = chunks.map((fragments) => {
  const fragmentNames = fragments.map(
    (x: any) => x?.definitions[0]?.name?.value,
  );
  return gql`
    ${LinkFragment}
    ${fragments.reduce(
      (acc: any, fragment) =>
        gql`
          ${acc}
          ${fragment}
        `,
      '',
    )}
    fragment ParentPage on Page {
      _meta {
        id
        uid
        tags
        lang
      }
      page_title
      sub_navigation {
        link_text
        link {
          ...LinkFragment
        }
      }
    }
    query page($uid: String!, $lang: String!) {
      page(uid: $uid, lang: $lang) {
        page_title
        abstract
        abstract_image
        seo_title
	      seo_description
	      seo_image
        slug
        sub_navigation {
          link_text
          link {
            ...LinkFragment
          }
        }
        hide_sub_nav
        cta_button {
          ...LinkFragment
        }
        cta_button_text
        cta_mobile_button_text
        parent {
          ...ParentPage
          ... on Page {
            parent {
              ...ParentPage
            }
          }
        }
        _meta {
          id
          uid
          tags
          lang
          alternateLanguages {
            id
            lang
          }
        }
        become_a_custmer_enabled
        body {
          __typename
          ${fragmentNames.map((name) => `...${name}\n`)}
        }
      }
    }
  `;
});
